import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line max-len
import CarSelectionNoResult from '../../../StandardApplicationEntrypoint/CarListingPage/CarSelection/CarSelectionNoResult';
import { CarSelectionContainer, Title } from '../../../StandardApplicationEntrypoint/CarListingPage/CarSelection/ui';
import { useCarListingState } from '../CarListingStateProvider';
import CarCard from './CarCard';

const CarSelection = () => {
    const {
        state: { variants, openFilterDrawer, total },
    } = useCarListingState();

    const { t } = useTranslation(['carList']);
    const navigate = useNavigate();

    if (variants.length === 0) {
        return (
            <CarSelectionContainer $showFilter={openFilterDrawer}>
                <CarSelectionNoResult />
            </CarSelectionContainer>
        );
    }

    return (
        <CarSelectionContainer $showFilter={openFilterDrawer}>
            <Title level={5}>{t('carList:noOfAvailable.vehicle', { count: total })}</Title>
            <Row gutter={[24, 40]} style={{ marginTop: '15px' }}>
                {variants.map(variant => (
                    <Col key={variant.id} sm={openFilterDrawer ? 24 : 12} xl={openFilterDrawer ? 8 : 6} xs={24}>
                        <CarCard onClick={() => navigate(`./${variant?.listing?.id}`)} variant={variant} />
                    </Col>
                ))}
            </Row>
        </CarSelectionContainer>
    );
};

export default CarSelection;
